<template>
  <div>
    <template v-for="(input, index) in value">
      <div class="items_group" :key="index">
        <div class="remove_items">
          <button v-if="index !== 0" @click="handleRemoveArray(index)">
            <span
              ><font-awesome-icon icon="times" size="2x"></font-awesome-icon
            ></span>
          </button>
        </div>
        <div class="flex align-end">
          <div class="input-wrap-group u-mt0">
            <atoms-input-select
              label="時間"
              :setKey="`socialActivitiesTimeFrom-${index}`"
              v-model="input.socialActivitiesTimeFrom"
              :options="
                useDefine.defineObject.SOCIALACTIVITIESTIME_OPTION_ARRAY
              "
              @input-emit="handleUpdateArrayValue"
            ></atoms-input-select>
            <span>時</span>
            <atoms-input-select
              label="none"
              :setKey="`socialActivitiesMinuteFrom-${index}`"
              v-model="input.socialActivitiesMinuteFrom"
              :options="
                useDefine.defineObject.SOCIALACTIVITIESMINUTE_OPTION_ARRAY
              "
              @input-emit="handleUpdateArrayValue"
            ></atoms-input-select>
            <span>分から</span>
          </div>
          <div class="input-wrap-group u-mt0">
            <atoms-input-select
              label="none"
              :setKey="`socialActivitiesTimeTo-${index}`"
              v-model="input.socialActivitiesTimeTo"
              :options="
                useDefine.defineObject.SOCIALACTIVITIESTIME_OPTION_ARRAY
              "
              @input-emit="handleUpdateArrayValue"
            ></atoms-input-select>
            <span>時</span>
            <atoms-input-select
              label="none"
              :setKey="`socialActivitiesMinuteTo-${index}`"
              v-model="input.socialActivitiesMinuteTo"
              :options="
                useDefine.defineObject.SOCIALACTIVITIESMINUTE_OPTION_ARRAY
              "
              @input-emit="handleUpdateArrayValue"
            ></atoms-input-select>
            <span>分まで</span>
          </div>
        </div>
        <atoms-input-textarea
          :label="`役割・日課`"
          placeholder="役割・日課"
          :required="false"
          v-model="input.socialActivitiesRolesAndDailyRoutine"
          :setKey="`socialActivitiesRolesAndDailyRoutine-${index}`"
          @input-emit="handleUpdateArrayValue"
        ></atoms-input-textarea>
      </div>
    </template>
    <div class="add_items" v-if="currentMaxIndex < dataMax">
      <button @click="handleAddArray()">
        <span
          ><font-awesome-icon icon="plus-circle" size="2x"></font-awesome-icon
        ></span>
        役割・日課を追加する
      </button>
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    setArrayKey: {
      type: String,
      required: true,
    },
    dataMax: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      currentMaxIndex: 0,
      useDefine: { defineObject: defineObject },
      baseObj: {
        socialActivitiesTimeFrom: '',
        socialActivitiesMinuteFrom: '',
        socialActivitiesTimeTo: '',
        socialActivitiesMinuteTo: '',
        socialActivitiesRolesAndDailyRoutine: '',
      },
    }
  },
  methods: {
    handleAddArray() {
      this.currentMaxIndex++
      this.$emit('add-array', this.setArrayKey, {
        socialActivitiesTimeFrom: '',
        socialActivitiesMinuteFrom: '',
        socialActivitiesTimeTo: '',
        socialActivitiesMinuteTo: '',
        socialActivitiesRolesAndDailyRoutine: '',
      })
    },
    handleRemoveArray(index) {
      this.currentMaxIndex--
      this.$emit('remove-array', this.setArrayKey, index)
    },
    handleUpdateArrayValue(setKey, setValue) {
      if (setKey && setValue) {
        const setKeyArray = setKey.split('-')
        this.$emit(
          'input-emit',
          this.setArrayKey,
          setKeyArray[0],
          setKeyArray[1],
          setValue
        )
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value.length === 0) {
        this.handleAddArray()
      }
      this.currentMaxIndex = this.value.length
    })
  },
}
</script>

<style lang="scss" scoped>
.input-wrap-group {
  .input-wrap {
    width: 100%;
  }
  span {
    white-space: nowrap;
    font-size: 12px;
  }
}
</style>
